import type { SVGProps } from 'react';

import { cn } from '@/lib/utils';

interface MinusIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export function MinusIcon({ className, ...props }: MinusIconProps) {
  return (
    <svg
      viewBox="0 0 15 1.73131"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('w-5 h-auto', className)}
      aria-hidden="true"
      {...props}
    >
      <path d="M14.1924 0C14.638 1.74944e-05 14.9999 0.362054 15 0.807617C15 1.25328 14.638 1.61619 14.1924 1.61621H0.808594C0.362919 1.61621 7.70137e-07 1.25329 0 0.807617C0.000120594 0.362044 0.362993 7.7001e-07 0.808594 0H14.1924Z" fill="currentColor" />
    </svg>
  );
}
